"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _reactDatePicker = _interopRequireDefault(require("react-date-picker"));
require("react-date-picker/dist/DatePicker.css");
require("react-calendar/dist/Calendar.css");
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputDate = props => {
  const onChangeDate = date => {
    if (date) {
      let moment = require("moment"); // require
      let newDate = moment(date).format("YYYY-MM-DD");
      props.onChange(newDate);
    } else {
      props.onChange("");
    }
  };
  let newValue;
  if (props.value === null || props.value === "") {
    newValue = "";
  } else {
    newValue = new Date(props.value + "T00:00:00");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2", {
      "is-invalid": props.error
    })
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_reactDatePicker.default, {
    value: newValue,
    onChange: onChangeDate,
    className: (0, _classnames.default)(props.inputSizeClass, {
      "is-invalid": props.error
    })
  })), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputDate;
exports.default = _default;